<template>
  <Production-Foreman
    foreman-type="concrete"
    :supplier="supplier"
  />
</template>
<script>
import ProductionForeman from './ProductionForeman.vue'

export default {
  components: {
    ProductionForeman,
  },
  props: {
    supplier: {
      type: String,
      default: '',
    },
  },
}
</script>
